var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07214 8.78101C6.06414 8.77101 6.06014 8.75801 6.05214 8.74801L0.267138 2.35201C0.112208 2.17088 0.027071 1.94036 0.027071 1.70201C0.027071 1.46366 0.112208 1.23314 0.267138 1.05201C0.270035 1.04911 0.27342 1.04674 0.277138 1.04501C0.348744 0.95735 0.438662 0.886417 0.540583 0.837184C0.642504 0.787951 0.753961 0.761611 0.867138 0.76001H12.4431C12.5584 0.761686 12.672 0.788715 12.7757 0.839178C12.8794 0.889641 12.9707 0.962303 13.0431 1.05201C13.1981 1.23314 13.2832 1.46366 13.2832 1.70201C13.2832 1.94036 13.1981 2.17088 13.0431 2.35201L7.24314 8.78101C7.17095 8.86579 7.0812 8.93389 6.98011 8.98058C6.87902 9.02728 6.76899 9.05146 6.65764 9.05146C6.54628 9.05146 6.43626 9.02728 6.33517 8.98058C6.23407 8.93389 6.14433 8.86579 6.07214 8.78101Z",
    fill: "#14AE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDd);
export default __webpack_public_path__ + "static/media/DD.252a781d20ae90087aab97f5c1fb5e03.svg";
export { ForwardRef as ReactComponent };